import { create } from 'zustand';
import { TCommercialProposal } from '../commercial-proposal';

interface ProposalState {
  proposal: TCommercialProposal | null;
  actions: ProposalStateActions;
}

interface ProposalStateActions {
  setProposal: (proposal: TCommercialProposal | null) => void;
}

export const useProposalStore = create<ProposalState>((set) => ({
  proposal: null,
  actions: {
    setProposal: (proposal: TCommercialProposal | null) => set({ proposal }),
  },
}));

export const useProposal = () => useProposalStore((state) => state.proposal);
export const useProposalActions = () =>
  useProposalStore((state) => state.actions);
